import { IProductGroupInterface } from "@components/Form/interface";
import { handleRefresh } from "@utils/manageValue";
import commonStore from "@zustand/common";

const handleBackToMain = () => {
  const { clearCenteredModal } = commonStore.getState();

  window.location.assign("/");
  return clearCenteredModal();
};

export const renderMasterPlant = (res: {
  status: boolean;
  message: IProductGroupInterface[];
}) => {
  const { status, message } = res;
  const { setOpenCenteredModal, clearCenteredModal } = commonStore.getState();

  if (!status) {
    setOpenCenteredModal({
      open: true,
      type: "warning",
      title: "Form-Common:master_plant_server_error_title",
      description: "Form-Common:master_plant_server_error_description",
      onClose: handleBackToMain,
      onOk: handleRefresh,
      btn: {
        isDisplayBtnCancel: true,
        isDisplayBtnConfirm: true,
        btnCancelText: "Common:back_to_main_page",
        btnConfirmText: "Common:refresh",
      },
    });
    return [];
  }

  if (message.length === 0) {
    setOpenCenteredModal({
      open: true,
      type: "warning",
      title: "Form-Common:master_plant_no_products_title",
      description: "Form-Common:master_plant_no_products_description",
      onClose: clearCenteredModal,
      onOk: handleBackToMain,
      btn: {
        isDisplayBtnCancel: false,
        isDisplayBtnConfirm: true,
        btnConfirmText: "Common:back_to_main_page",
      },
    });
    return [];
  }

  return message;
};
